"use strict";

import Toolbox from "./toolbox";

export default () => {
	const tabbers = document.querySelectorAll(".tabber");
	for (const tabber of tabbers) {
		if (tabber.dataset.initialised !== "true") {
			tabber.dataset.initialised = "true";
			const tabsContainer = tabber.querySelector(".tabs");

			/*
			const tabViews = document.querySelector(".tab-views");
			if (tabViews) {
				tabViews.addEventListener("transitionend", (e) => {
					const element = e.target;
				});
			} */

			if (tabsContainer) {
				tabsContainer.addEventListener("click", (e) => {
					//e.preventDefault();
					const clicked = e.target;
					if (clicked && clicked.classList.contains("tabber-button") && !clicked.classList.contains("active")) {
						//clicked.blur();
						const viewId = clicked.dataset.view;
						const tabber = Toolbox.closest(clicked, ".tabber");
						if (tabber) {
							const views = tabber.querySelectorAll(".tab-view");
							for (const view of views) {
								if (view.dataset.view !== viewId) {
									view.classList.remove("active");
								} else {
									view.classList.add("active");
								}
							}

							const tabs = tabber.querySelectorAll(".tabs button");
							for (const tab of tabs) {
								tab.classList.remove("active");
								tab.setAttribute("aria-selected", "false");
							}
							clicked.setAttribute("aria-selected", "true");
							clicked.classList.add("active");

						}
					}

				});
			}
		}
	}
};